import React from 'react';
import { connect } from 'react-redux';
import { __ } from 'i18n-for-browser';
import { Authorization } from 'glxl-helpers';
import PropTypes from 'prop-types';
import ws from '../ws';
import { UPDATE_FEEDBACK_READ, SET_TIMER, UPDATE_SCHOOLCLASS, UPDATE_GROUP } from '../actions/types';
import actions from '../actions';
import Loading from './elements/Loading';
import PopUp from './elements/PopUp';
import apiCall from "./apiCall";

const auth = new Authorization();

const { fetchUser, logout } = actions.user;
const { fetchGhettoRadioGroups } = actions.ghettoRadio;
const { fetchFeedback } = actions.feedback;
const { fetchProject, myProject, refreshProject, updateProject } = actions.project;
const { updateInputStates, updateMyState, finishedStep } = actions.gameStateInput;

window.timerId = null;
window.mainAuth = undefined;
let self = undefined;

export default function Auth(ToRender, allowedRoles = [], allowedSteps = null, props) {
  class Authorization extends React.Component {
    static propTypes = {
      dispatch: PropTypes.func.isRequired,
      history: PropTypes.shape({
        go: PropTypes.func,
        goBack: PropTypes.func,
        goForward: PropTypes.func,
        push: PropTypes.func,
        location: PropTypes.shape({}),
      }).isRequired,
      match: PropTypes.shape({
        isExact: PropTypes.bool,
        params: PropTypes.shape({}),
        path: PropTypes.string,
        url: PropTypes.string,
      }).isRequired,
      location: PropTypes.shape({
        hash: PropTypes.string,
        key: PropTypes.string,
        pathname: PropTypes.string,
      }).isRequired,
    };
    constructor(props) {
      super(props);
      const { user } = this.props;
      this.state = {
        user,
        authorized: true,
        noConnectionPopup: false,
        removedRoundPopup: false,
        messageFromAdmin: '',
        bankDisabledPopup: false,
      };
      this.user = props.user || {};
      this.mainAuth = !window.mainAuth;
      if (this.mainAuth) {
        window.mainAuth = this.mainAuth;
      }
      self = this;
    }

    getTimeDifferenceInSeconds = async () => {
      const res = await apiCall('/define/time');
      if (res) {
        return (new Date(res.time)).getTime() - (new Date()).getTime();
      }
      return 0;
    }

    componentWillMount = async () => {
      if (window.tijdverschil === undefined) {
        window.tijdverschil = await this.getTimeDifferenceInSeconds();
      }

      if (!this.mainAuth && window.mainAuth) return;
      if (!this.props.user.userDetails || !this.props.user.loggedIn) {
        this.props.dispatch(fetchUser());
      }
      this.setupWebSockets();
      if (this.props.location.pathname.startsWith('/bank') && this.props.project && this.props.project.bankEnabled === false) {
        this.setState({ bankDisabledPopup: true });
      }
    }

    componentDidUpdate(prevProps) {
      const currentPathIsBank = this.props.location.pathname.startsWith('/bank');
      const bankIsDisabled = this.props.project && this.props.project.bankEnabled === false;
      const pathWasNotBankBefore = !prevProps.location.pathname.startsWith('/bank');
      const bankWasJustDisabled = !prevProps.project || prevProps.project.bankEnabled !== false;

      if (currentPathIsBank && bankIsDisabled && (bankWasJustDisabled || pathWasNotBankBefore)) {
        this.setState({ bankDisabledPopup: true });
      }
    }

    componentWillUnmount() {
      clearTimeout(window.timerId);
      if (this.mainAuth) {
        window.mainAuth = false;
      }
    }

    /**
     * Handle websocket connection
     */
    setupWebSockets = () => {
      const { user, gameState, schoolClass } = this.props;
      const { userDetails } = user;
      window.top.postMessage(`${user.role}${sessionStorage.getItem('redirect') ? "-leader" : ""}`, '*');
      // Without the following conditions, we can't set up websockets
      if (!userDetails || !gameState.loaded || window.socket || !user.loggedIn || user.role === 'schoolcontact') return;
      // Set window.socket to true so it doesnt get past the conditions the next time
      window.socket = true;
      const schoolClassId = userDetails.group
        ? userDetails.group.SchoolClassId
        : userDetails.ownedClass
          ? userDetails.ownedClass.id
          : schoolClass.id;
      // Attempt to connect to the simulationgame namespace
      ws.connect('simulationgame')
        .then((s) => {
          // Update window.socket
          window.socket = s;

          window.socket.on('connect', () => {
            console.log('WS connect');
            // Tell the API we want ot join our schoolclasses room
            window.socket.emit('join', {
              token: user.token,
              room: `simulationgame-${schoolClassId}`,
              roundNumber: gameState.roundData.roundNumber,
              schoolClassId,
            }, ws.handleFailedEmit);
          });

          // Group specific event handlers
          // We joined the room
          window.socket.on('joined', ({ payload, who }) => {
            // This is so that the initial join wont refresh data,
            // but when we end up triggering another join because of a disconnect,
            // we do want to refresh data.
            const iJoined = this.props.user.userDetails.id === who;
            if (iJoined && window.joined) {
              this.refresh();
            }
            if (iJoined) {
              window.joined = true;
            }
            if (user.role === 'groupleader' || user.role === 'groupmember') {
              const { gameStateInput } = this.props;
              if (!gameStateInput.myLatestState.joined) {
                this.props.dispatch(updateMyState({ ...payload[gameState.roundData.roundNumber][userDetails.group.id], joined: true } || { joined: true }, true));
                this.props.dispatch(updateInputStates(payload || {}));
              }
            }
          });

          window.socket.on('scoreVisibilityChanged', (newValue) => {
            this.props.dispatch(updateProject({ ...this.props.project, showScores: newValue }));
          });

          window.socket.on('allFeedbackSetToRead', () => {
            this.props.dispatch(fetchFeedback());
          });
          if (this.user.role !== 'schoolcontact') {
            window.socket.on('removedCurrentRound', () => {
              self.setState({ removedRoundPopup: true });
            });
          }

          if (user.role === 'groupleader' || user.role === 'groupmember') {
            // There has been an update in gameStateInput
            window.socket.on('updatedInput', ({ ...payload }) => {
              const { gameStateInput } = this.props;
              const { roundNumber } = gameStateInput.myLatestState;
              const grpId = Object.keys(payload[roundNumber]).length ? parseInt(Object.keys(payload[roundNumber])[0], 10) : -1;
              const isOwnGroup = (grpId !== -1 && grpId === gameStateInput.groupId);
              let updateOwnGroup = payload[roundNumber][grpId].forceUpdate ||
                (isOwnGroup && payload[roundNumber][grpId].updateOwnGroup && this.props.user.role === 'groupmember');
              if (this.props.user.role === 'groupmember') {
                updateOwnGroup = true;
              }
              if (updateOwnGroup || (gameStateInput.myLatestState.joined && !isOwnGroup)) {
                payload[roundNumber][grpId].updateOwnGroup = undefined;
                this.props.dispatch(updateInputStates(payload, updateOwnGroup));
              }
            });
          }
          window.socket.on('setTimer', (payload) => {
            this.props.dispatch({ type: SET_TIMER, payload });
          });
          // Simulationstep complete
          window.socket.on('finishedSimulationStep', (payload) => {
            if (payload.error) {
              console.error(payload.error);
              alert(payload.error);
              return;
            }
            console.log('finished simulation step', payload);
            if (user.role === 'groupleader' || user.role === 'groupmember') {
              this.props.dispatch(finishedStep(payload));
            }

            // If we processed the last step, prevent data reload
            if (!['groupleader', 'groupmember'].includes(user.role)) {
              this.refresh();
              return;
            }
            if (payload.step !== 'SIMULATION_SPENDING') {
              this.refresh();
            } else {
              this.preventReload = true;
            }
          });
          // feedback item has been read
          window.socket.on('feedbackRead', (payload) => {
            if (this.props.user.userDetails.group && this.props.user.userDetails.group.id === payload.groupId) {
              this.props.dispatch({
                type: UPDATE_FEEDBACK_READ,
                payload: {
                  id: payload.feedbackId,
                  read: payload.read,
                },
              });
            }
          });
          window.socket.on('schoolClassUpdate', (cls) => {
            if (this.props.schoolClass.id == cls.id) {
              this.props.dispatch({
                type: UPDATE_SCHOOLCLASS,
                payload: cls,
              });
            }
          });
          window.socket.on('groupUpdated', (groupChanges) => {
            if (this.props.group.id === groupChanges.id) {
              this.props.dispatch({
                type: UPDATE_GROUP,
                payload: groupChanges,
              });
            }
            // 🤮
            if (Array.isArray(this.props.schoolClass.Groups)) {
              const indexOfGroup = this.props.schoolClass.Groups.findIndex(g => g.id === groupChanges.id);
              if (indexOfGroup !== -1) {
                this.props.schoolClass.Groups[indexOfGroup] = {
                  ...this.props.schoolClass.Groups[indexOfGroup],
                  ...groupChanges,
                };
                this.props.dispatch({ type: UPDATE_SCHOOLCLASS, payload: { Groups: this.props.schoolClass.Groups } });
              }
            }
          });
          window.socket.on('messageFromAdmin', payload => {
            if (this.props.user.role.startsWith('group')) {
              self.setState({ messageFromAdmin: payload.message });
            }
          });
          // Classleader activated something
          window.socket.on('activate', () => {
            if (this.props.user.role.startsWith('group')) {
              this.refresh(this.props.user, true);
            } else if (this.props.user.role === 'classleader') {
              this.props.dispatch(refreshProject());
            }
          });
          window.socket.on('error', (err) => {
            console.log('WS error', err);
            self.setState({ noConnectionPopup: true });
          });
          window.socket.on('disconnect', (reason) => {
            self.setState({ noConnectionPopup: true });
          });
          window.socket.on('bankDisabled', () => {
            this.refresh();
          });
        });
    };

    /**
     * @name roleAuthorized
     * @return {boolean}
     */
    roleAuthorized = () => {
      const { role } = this.props.user;
      if (!allowedRoles.length) return true;
      if (allowedRoles.includes(role)) return true;
      return false;
    };

    /**
     * Method to refresh data and dispatch data changes
     * @return {Promise<void>}
     */
    refresh = async (user = this.props.user) => {
      if (!this.mainAuth && window.mainAuth) return false;
      if (this.preventReload) return;
      let projectId;
      if (!user || !user.userDetails) return;
      const { role, userDetails } = user;
      if (!userDetails) return null;
      const { ownedClass, group, ownedGroup } = userDetails;
      if (ownedClass) projectId = ownedClass.ProjectId;
      if (group) projectId = group.ProjectId;
      if (ownedGroup) projectId = ownedGroup.ProjectId;
      if (!projectId && role === 'schoolcontact') {
        this.props.dispatch(myProject());
        return;
      }
      const schoolClassId = user.userDetails.schoolClass ? user.userDetails.schoolClass.id : null;
      this.props.dispatch(fetchProject(projectId, schoolClassId));
      if (role === 'groupmember' || role === 'groupleader') {
        this.props.dispatch(fetchFeedback());
      }
      if (role === 'classleader') {
        this.props.dispatch(fetchGhettoRadioGroups());
      }
    };

    redirectToLogin() {
      this.props.dispatch(logout());
      const { location } = this.props;
      const redirect = location.pathname + location.search;
      this.props.history.push(`/login?redirect=${redirect}`);
    }

    render() {
      const {
        user, gameState, feedback, history, match, location, gameStateInput,
      } = this.props;
      if (!this.user.loggedIn && user.loggedIn) {

        this.refresh(user);
      }
      this.setupWebSockets();
      this.user = { ...user };

      const waitForInputLoad = ((['groupleader', 'groupmember'].includes(user.role)) && !gameStateInput.myLatestState.joined);
      const waitForGameState = (user.role !== 'schoolcontact') && !gameState.loaded;
      if (!auth.getAuthToken() && !sessionStorage.getItem('token')) this.redirectToLogin();
      if (!user.loggedIn || !user.userDetails || waitForGameState || waitForInputLoad) {
        return (
          <React.Fragment>
            {this.mainAuth || !window.mainAuth ? <Loading /> : null}
            {this.renderBankDisabledPopup()}
          </React.Fragment>
        );
      }
      if ((user.role === 'groupleader' || user.role === 'groupmember') && !feedback.loaded) {
        return (
          <React.Fragment>
            {this.mainAuth || !window.mainAuth ? <Loading /> : null}
            {this.renderBankDisabledPopup()}
          </React.Fragment>
        );
      }
      if (!this.roleAuthorized()) {
        if (user.role === 'classleader') {
          history.push('/portal/classleader');
          return (<div />);
        } else if (user.role !== 'schoolcontact') {
          history.push('/');
          return (<div />);
        }
      }

      if (allowedSteps && !allowedSteps.includes(gameState.currentStep)) {
        if (props && props.redirect === false) {
          return (<div />);
        }
        if (gameState.roundData.state === 'END' || gameState.currentStep === 0) {
          history.push('/portal/group');
          return (<div />);
        }

        history.push(gameState.simGameEntry);
        return (<div />);
      }
      if (gameStateInput.history) {
        document.getElementsByTagName('body')[0].classList.add('history');
      } else {
        document.getElementsByTagName('body')[0].classList.remove('history');
      }

      /**
       * If history has been set in sessionStorage, that means that
       * we went back to the portal while in history view.
       *
       * When we go back into the game, we want to go back to the round
       * we were currently watching.
      */
      const setHistory = parseInt(window.sessionStorage.getItem('history'), 10);
      if (!isNaN(setHistory) && !this.props.location.pathname.startsWith('/portal') && gameStateInput.loaded && this.mainAuth) {
        window.sessionStorage.setItem('history', '');
        this.props.dispatch(actions.feedback.setRound(setHistory));
      }

      return (
        <React.Fragment>
          <ToRender
            {...props}
            history={history}
            match={match}
            location={location}
          />
          {
            this.state.noConnectionPopup
              ? <PopUp
                title={__('sim_geen_verbinding_popup_titel')}
                description={__('sim_geen_verbinding_popup_beschrijving')}
                showPopUp={true}
                customButton={{
                  text: __('sim_herladen'),
                  action: () => {
                    window.location.reload();
                  },
                }}
                closePopUpClick={() => { }}
              />
              : null
          }
          {
            this.state.messageFromAdmin.length
              ? <PopUp
                title={__('sim_bericht_vanuit_admin')}
                description={__(this.state.messageFromAdmin)}
                showPopUp={true}
                customButton={{
                  text: __('sim_sluiten'),
                  action: (ev) => {
                    if (ev && typeof ev.stopPropagation === 'function') {
                      ev.stopPropagation();
                    }
                    this.setState({ messageFromAdmin: '' });
                  },
                }}
                closePopUpClick={(ev) => {
                  if (ev && typeof ev.stopPropagation === 'function') {
                    ev.stopPropagation();
                  }
                  this.setState({ messageFromAdmin: '' });
                }}
              />
              : null
          }
          {this.state.removedRoundPopup ? (
            <PopUp
              title={__('sim_huidige_ronde_verwijderd_titel')}
              description={__('sim_huidige_ronde_verwijderd_beschrijving')}
              showPopUp={true}
              customButton={{
                text: __('sim_herladen'),
                action: () => {
                  window.location.href = '/portal';
                },
              }}
              closePopUpClick={() => { }}
            />
          ) : null}
          {this.renderBankDisabledPopup()}
        </React.Fragment>
      );
    }

    renderBankDisabledPopup() {
      if (!this.state.bankDisabledPopup) return null;
      return (
        <PopUp
          title={__('sim_bank_uitgeschakeld_melding_titel')}
          description={__('sim_bank_uitgeschakeld_melding_beschrijving')}
          showPopUp={true}
          customButton={{
            text: __('OK'),
            action: () => {
              this.setState({ bankDisabledPopup: false });
              window.location.href = '/';
            },
          }}
          closePopUpClick={() => {
            this.setState({ bankDisabledPopup: false });
            window.location.href = '/';
          }}
        />
      );
    }
  }
  return connect((state) => (state))(Authorization);
}



// WEBPACK FOOTER //
// ./src/components/auth.js